<template>
  <div :class="bem()">
    <slot v-if="totalResults > 0" :totalResults="totalResults" :processingTime="processingTime" :query="query" :resultStart="resultStart" :resultEnd="resultEnd">
      {{ totalResults.toLocaleString() }} results found in {{ processingTime.toLocaleString() }}ms
    </slot>
    <span v-if="totalResults < 1">
      No result found.
    </span>
  </div>
</template>

<script>
import { Stats } from 'vue-instantsearch'
export default {
  name: 'ais-stats',
  extends: Stats
}
</script>
